import { useEffect, useState } from 'react';

const DESKTOP_WIDTH = 1024;

export const useIsDesktop = () => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const check = () => setIsDesktop(window.innerWidth >= DESKTOP_WIDTH);

    check(); // initial
    window.addEventListener('resize', check);

    return () => window.removeEventListener('resize', check);
  }, []);

  return isDesktop;
};
